module.exports = __webpack_public_path__ + "dingbeauty-build/img/404.fe7b497c.svg";